<template>
  <div class="submit_container">
    <input
      class="field"
      type="text"
      autocomplete="phone"
      v-model="phone"
      :class="{ required: !isPhone }"
      placeholder="Введите телефон"
    />
    <input
      class="field"
      type="text"
      autocomplete="email"
      v-model="email"
      :class="{ required: !isEmail }"
      placeholder="Введите адрес электронной почты"
    />
    <div v-if="is_success">Заявка отправлена. С Вами скоро свяжутся</div>
    <div v-if="is_error">Не удалось отправить заявку</div>
    <button :disabled="!isSendable" @click="submit()">{{title}}</button>
  </div>
</template>

<script>

export default {
  props: ["title"],
  emits: ["submit"],
  data() {
    return {
      email: undefined,
      phone: undefined,
      is_sending: false,
      is_success: false,
      is_error: false,
    };
  },

  computed: {
    isSendable() {
      return !this.is_sending && this.isEmail && this.isPhone
    },
    isEmail() {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
    },

    isPhone() {
      return /^[+]?[\s()]*([0-9][\s()]*){6,20}$/.test(this.phone)
    }
  },
  methods: {
    submit() {
      this.$emit('submit', {email: this.email, phone: this.phone})
    },
  },
};
</script>

<style scoped>
.field {
  margin: 5px 0;
}
.submit_container {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.submit_container > button {
  background: white;
  border: 1px solid #fc5a0a;
  color: black;

  padding: 8px;
  margin-top: 15px;
  font-size: 12pt;
  font-weight: 600;
  opacity: 0.8;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  justify-content: center;
}

.submit_container > button:hover {
  opacity: 1;
}

.submit_container > button:disabled {
  color: grey;
  border-color: grey;
}

.submit_container > button > .indicator {
  width: 17px;
  height: 17px;
  position: relative;
  overflow: hidden;
  margin: auto 5px;
}

.submit_container > button > .indicator > div {
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 50%;
  border-color: orange transparent transparent transparent;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.submit_container > button > .indicator > div:nth-child(1) {
  animation-delay: -0.45s;
}

.submit_container > button > .indicator > div:nth-child(2) {
  animation-delay: -0.3s;
}

.submit_container > button > .indicator > div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
